import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SimpleGuard } from '@delon/auth';
import { environment } from '@env/environment';
// layout
import { LayoutBasicComponent } from '../layout/basic/basic.component';
import { LayoutBlankComponent } from '../layout/blank/blank.component';
import { LayoutPassportComponent } from '../layout/passport/passport.component';
import { LayoutComponent } from '../layout/layout/layout.component';
// single pages
import { CallbackComponent } from './passport/callback.component';
import { UserLockComponent } from './passport/lock/lock.component';
// passport pages
import { UserLoginComponent } from './passport/login/login.component';
import { UserRegisterResultComponent } from './passport/register-result/register-result.component';
import { UserRegisterComponent } from './passport/register/register.component';
import { PasswordSetComponent } from './passport/password-set/password-set.component';
import { LoadingComponent } from './passport/loading/loading.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'home',
    loadChildren: () => import('../pages/navigation/navigation.module').then((m) => m.NavigationModule),
    data: {
      title: '首页',
      breadcrumb: '首页',
      menu_data: 'home',
    },
  },
  {
    path: 'setting',
    loadChildren: () => import('../pages/setting/setting.module').then((m) => m.SettingModule),
    data: {
      title: '设置',
      breadcrumb: '设置',
      menu_data: 'setting',
    },
  },
  {
    path: 'help',
    loadChildren: () => import('../pages/help-center/help-center.module').then((m) => m.HelpCenterModule),
    data: {
      title: '版本介绍',
      breadcrumb: '版本介绍',
      menu_data: 'setting',
    },
  },
  {
    path: 'personnel',
    loadChildren: () => import('../pages/personnel/personnel.module').then((m) => m.PersonnelModule),
    data: {
      title: '人事管理',
      breadcrumb: '人事管理',
      menu_data: 'personnel',
    },
  },
  {
    path: 'headhunter',
    loadChildren: () => import('../pages/headhunter/headhunter.module').then((m) => m.HeadhunterModule),
    data: {
      title: '猎头端',
      breadcrumb: '猎头端',
      menu_data: 'headhunter',
    },
  },
  // {
  //   path: 'dormitory',
  //   loadChildren: () => import('../pages/dormitory/dormitory.module').then((m) => m.DormitoryModule),
  //   data: {
  //     title: '宿舍管理',
  //     breadcrumb: '宿舍管理',
  //     menu_data: 'dormitory',
  //   },
  // },
  {
    path: '111111',
    component: LayoutComponent,
    canActivate: [SimpleGuard],
    data: {
      breadcrumb: 'home',
    },
    children: [
      // { path: 'promote', redirectTo: 'promote', pathMatch: 'full' },
      // {
      //   path: 'promote',
      //   loadChildren: () => import('../pages/promote/promote.module').then((m) => m.PromoteModule),
      //   data: {
      //     breadcrumb: '推广端',
      //     menu_data: 'promote',
      //   },
      // },
      // {
      //   path: 'material',
      //   loadChildren: () => import('../pages/material/material.module').then((m) => m.MaterialModule),
      //   data: {
      //     breadcrumb: '素材中心',
      //     menu_data: 'material',
      //   },
      // },
    ],
  },
  // 空白布局
  // {
  //     path: 'blank',
  //     component: LayoutBlankComponent,
  //     children: [
  //     ]
  // },
  // passport
  {
    path: 'passport',
    component: LayoutPassportComponent,
    children: [
      { path: 'login', component: UserLoginComponent, data: { title: '登录' } },
      { path: 'password-set', component: PasswordSetComponent, data: { title: '密码设置' } },
      { path: 'loading', component: LoadingComponent, data: { title: '登录' } },
      { path: 'register', component: UserRegisterComponent, data: { title: '注册', titleI18n: 'pro-register' } },
      {
        path: 'register-result',
        component: UserRegisterResultComponent,
        data: { title: '注册结果', titleI18n: 'pro-register-result' },
      },
      { path: 'lock', component: UserLockComponent, data: { title: '锁屏', titleI18n: 'lock' } },
    ],
  },
  // 单页不包裹Layout
  { path: 'passport/callback/:type', component: CallbackComponent },
  { path: '**', redirectTo: 'exception/404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: environment.useHash,
      // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
      // Pls refer to https://ng-alain.com/components/reuse-tab
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class RouteRoutingModule {}
